import AnalyticsUtil from './AnalyticsUtil';

export const pushUserEngagement = () => {
    const queryString = window.location.search;
    if (queryString.length > 0) {
        const queryParams = new URLSearchParams(queryString);
        //Identifies which site sent the traffic, and is a required parameter.
        const utmSource = queryParams.get('utm_source');
        //Identifies what specifically was clicked to bring the user to the site
        const utmContent = queryParams.get('utm_content');
        //Identifies what type of link was used, such as cost per click or email.
        const utmMedium = queryParams.get('utm_medium');

        if (utmSource && utmMedium && utmContent) {
            AnalyticsUtil.push({
                event: 'track_event',
                category: utmSource,
                action: utmContent,
                label: utmMedium
            });
        }
    }
};
